import {
  GENERATOR_ACCEPTED_MIME_TYPES,
  GENERATOR_MAX_FILE_BYTES,
  type GeneratorAcceptedMimeType,
} from './GeneratorAttachedFile';

export async function hashFileContent(buffer: ArrayBuffer): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', buffer);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return btoa(binary);
}

export function normalizeGeneratorMimeType(file: File): GeneratorAcceptedMimeType | null {
  const mime = file.type || guessMimeFromName(file.name);
  if (GENERATOR_ACCEPTED_MIME_TYPES.includes(mime as GeneratorAcceptedMimeType)) {
    return mime as GeneratorAcceptedMimeType;
  }
  return null;
}

function guessMimeFromName(name: string): string {
  const lower = name.toLowerCase();
  if (lower.endsWith('.pdf')) return 'application/pdf';
  if (lower.endsWith('.txt')) return 'text/plain';
  if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'image/jpeg';
  if (lower.endsWith('.png')) return 'image/png';
  if (lower.endsWith('.gif')) return 'image/gif';
  if (lower.endsWith('.webp')) return 'image/webp';
  return '';
}

export function validateGeneratorFileSize(size: number): string | null {
  if (size > GENERATOR_MAX_FILE_BYTES) {
    return 'Die Datei ist zu groß (max. 10 MB).';
  }
  if (size === 0) {
    return 'Die Datei ist leer.';
  }
  return null;
}

export function totalFilesByIdBytes(filesById: Record<string, { size: number }>): number {
  return Object.values(filesById).reduce((sum, f) => sum + f.size, 0);
}
